/* index.js */

"use strict";

module.exports = {
    Base: require("./src/InputBaseControlComponent"),
    Textfield: require("./src/textfield/InputBaseTextfieldControlComponent"),
    OptionSelection: {
        Single: require("./src/option_selection/single/InputBaseSingleOptionSelectionControlComponent"),
        Multiple: require("./src/option_selection/multiple/InputBaseMultipleOptionSelectionControlComponent"),
    },
    Action: require("./src/action/InputBaseActionControlComponent"),
    Boolean: require("./src/boolean/InputBaseBooleanControlComponent"),
};
